import { createFileRoute, useParams } from '@tanstack/react-router';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import DataIndexListPage from '@/pages/workspaces/data-index/index.page';
import { DataIndexRoute } from '@/pages/workspaces/data-index/routing';
import { DataIndexTypeResolver } from '@/pages/workspaces/data-index/data-index-type-resolver';
import { LastWorkspaceResolver } from './-route-layouts';

function DataIndexTypeRoute() {
  const { type } = useParams({ from: '/_authenticated/workspaces/$workspaceId/data-index/$type/' });

  return (
    <LastWorkspaceResolver>
      <DataIndexTypeResolver segment={type}>
        {(dataIndexType) => (
          <DataIndexRoute type={dataIndexType}>
            <RumPageRendered>
              <DataIndexListPage type={dataIndexType} />
            </RumPageRendered>
          </DataIndexRoute>
        )}
      </DataIndexTypeResolver>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/data-index/$type/')({
  component: DataIndexTypeRoute,
});
